import { centerable as g } from "../decorators/centerable.js";
import { uploadable as n } from "../decorators/uploadable.js";
import { ALIGN_CLASSES as u } from "../../constants.js";
import "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const m = g(
  n({
    inline: !0,
    draggable: !0,
    attrs: {
      type: { default: "inlineImage" },
      src: {},
      linkUrl: { default: "" },
      width: { default: "" },
      displayWidth: { default: "" },
      height: { default: "" },
      text: { default: "" },
      className: { default: "" }
    },
    group: "inline",
    parseDOM: [
      {
        tag: ".intercom-inline-image",
        priority: 60,
        getAttrs(t) {
          let e = t;
          return {
            src: e.getAttribute("src"),
            text: e.getAttribute("alt"),
            width: t.getAttribute("data-width") || t.style.width.replace("px", ""),
            className: t.getAttribute("data-class-name") || ""
          };
        }
      },
      {
        tag: "img[src]",
        getAttrs(t) {
          return {
            src: t.getAttribute("src"),
            linkUrl: t.getAttribute("data-link-url"),
            width: t.getAttribute("data-width") || t.style.width.replace("px", ""),
            height: t.getAttribute("data-height"),
            text: t.getAttribute("alt"),
            className: t.getAttribute("data-class-name") || ""
          };
        }
      }
    ],
    toDOM(t) {
      let { src: e, width: i, displayWidth: a, height: r, text: l, className: s } = t.attrs;
      return a = a || i, [
        "img",
        {
          src: e,
          alt: l,
          class: `${u[t.attrs.alignment]} intercom-inline-image`,
          style: `width: ${a}px;`,
          "data-link-url": t.attrs.linkUrl,
          "data-height": r,
          "data-width": i,
          "data-class-name": s
        }
      ];
    }
  })
);
export {
  m as inlineImageSpec
};
